import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { userActions } from "../../_actions";
import { Input, Pagination, Routes, Table } from "../../_components";
import { userConstants } from "../../_constants";
import { useModal } from "../../hooks/use-modal";
import { MoveDataModal } from "./components";
import "./css/users-list.scss";
import copyIcon from "./img/copy.webp";

const formatData = (users, onClick) => {
  return users.map((user, index) => {
    return [
      index + 1,
      `${user?.firstname} ${user?.lastname}` || "-",
      user?.national_id || "-",
      user?.verify_code || "-",
      user?.cell_phone || "-",
      user?.id || "-",
      <img
        className="copy_icon"
        src={copyIcon}
        alt="اقدام اصلاحی"
        onClick={() => onClick(user?.id)}
      />,
    ];
  });
};

export const SuperAdminUsersList = () => {
  const dispatch = useDispatch();
  const globalStorage = useSelector((state) => state.globalStorage);
  const { hospital_id } = useParams();
  const [isOpenMoveModal, openMoveModal, closeMoveModal] = useModal();
  const [activeUserId, setActiveUserId] = useState(null);
  const [activePage, setActivePage] = useState(1);
  const [totalPage, setTotalPage] = useState(10);
  const [users, setUsers] = useState([
    [
      { child: "ردیف" },
      { child: "نام و نام خانوادگی" },
      { child: "کد ملی" },
      { child: "کد فعالسازی" },
      { child: "شماره تلفن همراه" },
      { child: "ایدی" },
      { child: "عملیـات" },
    ],
  ]);
  const [formValues, setFormValues] = useState({
    menu: null,
    submenu: null,
    year: null,
    newUser: null,
  });
  const [searchValue, setSearchValue] = useState();
  const [delayedSearchValue, setDelayedSearchValue] = useState();

  useEffect(() => {
    const waveElement = document.querySelector(".wave");
    waveElement.classList.add("hidden");
    return () => {
      waveElement.classList.remove("hidden");
    };
  }, []);

  useEffect(() => {
    dispatch(
      userActions.API(
        "get",
        `v1/su_admin/hospital/users?hospital_id=${hospital_id}&per=24&page=${activePage}${
          delayedSearchValue ? `&query=${delayedSearchValue}` : ""
        }`,
        null,
        true,
        false,
        JSON.parse(localStorage.getItem("tokenSuperAdmin"))
      )
    )
      .then((res) => {
        setTotalPage(res.data.meta.total_pages);
        setUsers((pervState) => [
          pervState[0],
          ...formatData(res.data.users, onOpenMoveModal),
        ]);
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
    // eslint-disable-next-line
  }, [globalStorage.year, activePage, delayedSearchValue]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDelayedSearchValue(searchValue);
    }, 1000);

    return () => {
      clearTimeout(handler);
    };
  }, [searchValue]);

  const onChangeForm = (name, value) => {
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const reset = () => {
    closeMoveModal();
    setActiveUserId(null);
    setFormValues({
      menu: null,
      submenu: null,
      year: null,
      newUser: null,
    });
  };

  const onClose = () => {
    dispatch(
      userActions.question("انصراف", "آیا از انصراف اطمینان دارید؟")
    ).then((r) => {
      if (r.value) {
        reset();
      }
    });
  };

  const onOpenMoveModal = (id) => {
    openMoveModal();
    setActiveUserId(id);
  };

  return (
    <div className="container-fluid users">
      <Routes page="superAdmin/users" />
      <div className="search_input_parent">
        <Input
          value={searchValue}
          onChange={setSearchValue}
          placeholder="جستجو..."
          containerClassName="search_input"
        />
      </div>
      <Table
        className="mt-3"
        headers={users[0]}
        data={users.length === 1 ? null : users.slice(1)}
      />
      <div className="pagination_parent">
        <Pagination
          totalPage={totalPage}
          active={activePage}
          callBack={setActivePage}
        />
      </div>
      {isOpenMoveModal && (
        <MoveDataModal
          onClose={onClose}
          formValues={formValues}
          onChangeForm={onChangeForm}
          hospitalId={hospital_id}
          activeUserId={activeUserId}
          reset={reset}
        />
      )}
    </div>
  );
};
